import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imReportTypeFilter', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/filters/report-type/report-type-filter.html'),
        controller: 'ReportTypeFilterController',
        controllerAs: 'ReportTypeFilterCtrl',
        bindings: {
            reportType: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/report-type/report-type-filter.component.ts